<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>系统更新日志</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <div>
      <el-timeline>
        <el-timeline-item center timestamp="系统反馈/系统建议" placement="top">
          <el-card>
            <h4>《系统反馈/系统建议》 钉钉联系人：宋旷</h4>
          </el-card>
        </el-timeline-item>
        <el-timeline-item v-for="(log, index) in visibleChangelog" :key="index" center :timestamp="log.timestamp"
          placement="top">
          <el-card v-if="log.items && log.items.length">
            <template v-for="(item, itemIndex) in log.items" :key="itemIndex">
              <p v-if="itemIndex > 0"> &nbsp;</p>
              <h4>{{ item.title }}</h4>
              <p v-for="(line, lineIndex) in item.lines" :key="lineIndex">{{ line }}</p>
            </template>
          </el-card>
          <template v-else>
            {{ log.text }}
          </template>
        </el-timeline-item>
      </el-timeline>
    </div>
<!-- 
    <div style="margin-top:30px;">
      <el-input type="textarea" :rows="6" style="width: 98%"></el-input>
    </div> -->
  </el-card>
</template>

<script>
import changelog from "./changelog";

export default {
  name: "version",
  data() {
    return {
      changelog,
    };
  },
  computed: {
    visibleChangelog() {
      return this.changelog.filter((log) => !log.hidden);
    },
  },
  methods: {

  },
  mounted() { },
};
</script>
<style lang="less">
.el-main h4 {
  margin-bottom: 10px;
}.el-main p {
  line-height: 1.3em;
}
</style>